/** Soft discard prompt for Setup drawers. Returns true when close may proceed. */
export function confirmDiscardIfDirty(dirty: boolean): boolean {
  if (!dirty) return true;
  return window.confirm("Discard unsaved changes?");
}
